export enum LineKinds {
  Normal = 1,
  Dotted = 2,
  Double = 3,
}
